/// <amd-module name="Tfs/Charting/ChartProviders" />

export class ChartProviders {
    //A common definition for features to reference their server side implementation
    public static witQueries: string = "WorkitemTracking.Queries";
    public static testReports: string = "TestManagement.Reports";
    public static testAuthoringMetadata: string = "TestManagement.AuthoringMetadata";
    public static testRunSummary: string = "TestManagement.RunSummary";
}
